// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../imgs/logoBabitaW.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../imgs/iconWhatsApp.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../imgs/bemVindo/phoneIcon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../imgs/bemVindo/emailIcon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.containerBoasVindas{
    display: flex;
    flex-direction: column;
    align-items: center;
    /* width    : 100vw; */
    max-width: 100vw;
    min-height: 100vh;
    min-height: 100svh;
    /* max-height: 100vh;
    max-height: 100svh; */
    background-color: var(--black-color);
    background: linear-gradient(0deg, #3a3a3a 0%, #121212 100%);
}


.containerBoasVindas .subtitle1,
.containerBoasVindas .subtitleApp2{
    position: relative;
    z-index: 20;
    font-family: "Poppins", sans-serif;
    font-weight: 700;
    color: var(--white-color);
    font-size: 2em;
    margin-top: 30px;
    text-align: center;
    margin-bottom: 20px;
}


.containerBoasVindas .logobabita{
    position: relative;
    z-index: 20;
    min-width: 10vw;
    max-width: 10vw;
    margin-top: 5px;
    margin-bottom: 20px;
    align-self: center;
    aspect-ratio: 350/111;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
    background-repeat: no-repeat;
    z-index: 18;
    margin-top: 20px;
    /* filter: drop-shadow(0px 0px 2px var(--white-color)) drop-shadow(0px 0px 2px #0000004a); */
}

.containerBoasVindas .player{
    position: relative;
    z-index: 20;
}


.containerBoasVindas .btnComunidade{
    position: relative;
    z-index: 20;
    display: flex;
    align-items: center;
    padding: 5px 20px;
    background-color: var(--white-color);
    font-family: "Poppins", sans-serif;
    font-weight: 700;
    margin-top: 40px;
    font-size: 1.2em;
    cursor: pointer;
    border-radius: 15px;
}

.containerBoasVindas .btnComunidade .imgWp{
    position: relative;
    z-index: 20;
    min-width: 50px;
    max-width: 50px;
    margin-left: 10px;
    align-self: center;
    aspect-ratio: 1/1;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: contain;
    background-repeat: no-repeat;
}


.containerBoasVindas .divisor{
    position: relative;
    z-index: 20;
    width: 80vw;
    height: 2px;
    margin: 30px 0 20px 0;
    background-color: var(--white-color);
}

.containerBoasVindas .subtitleApp{
    position: relative;
    z-index: 20;
    font-family: "Poppins", sans-serif;
    font-weight: 700;
    margin-bottom: 40px;
    font-size: 1.9em;
    color: var(--white-color);
}






/* APP LINKS */



.containerBoasVindas .subtitleApp1{
    background-color: transparent;
}



.containerBoasVindas .dataVideos{
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    color: #FFFFFF;
    font-size: 1.5em;
    text-align: center;
    width: 50vw;
    margin: 0 auto;
}


.containerBoasVindas .playerPrimeiro{
    margin-bottom: 8px;
}

.containerBoasVindas .dataPrimeiroVideo{
    margin-bottom: 40px;
}

.containerBoasVindas .playerSegundo{
    margin-bottom: 8px;
}

.containerBoasVindas .dataSegundoVideo{
    margin-bottom: 40px;
}



/* RELACIONAMENTO */

.containerBoasVindas .relacionamento{
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 20;
    width: 80vw;
    padding: 30px 10vw;
    font-family: "Poppins", sans-serif;
    font-weight: 700;
    font-size: 1em;
    color: var(--white-color);
    margin-bottom: 60px;
    background-color: #3a3a3ab4;
    border-top: 1px solid var(--white-color);
    border-bottom: 1px solid var(--white-color);
}

.containerBoasVindas .relacionamento > div{
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.containerBoasVindas .relacionamento .intro{
    flex-direction: column;
    width: 18vw;
}

.containerBoasVindas .relacionamento span{
    font-weight: 500;
}

.containerBoasVindas .relacionamento  .icon{
    width: 50px;
    aspect-ratio: 1/1;
    margin-right: 20px;
}


.containerBoasVindas .relacionamento .intro {
    align-items: flex-start;
}

.containerBoasVindas .relacionamento .textInfoTel .icon{
 background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center/contain;
}


.containerBoasVindas .relacionamento .textInfoEmail .icon{
 background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center/contain;
}

   .containerBoasVindas .relacionamento .textInfoWp{
    display: flex;
    align-items: center;
    background-color: var(--white-color);
    padding: 8px 20px;
    font-family: "Poppins", sans-serif;
    font-weight: 700;
    cursor: pointer;
    border-radius: 10px;
    max-height: 70px;
    color: var(--black-color);
}

.containerBoasVindas .relacionamento .textInfoWp .icon{
    width: 50px;
    aspect-ratio: 1/1;
    margin-right: 10px;
}

.containerBoasVindas .relacionamento .textInfoWp .icon{
 background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center/contain;
 cursor: pointer;
}






/* BOLHAS */

.containerBoasVindas .bubble{
    position: fixed;
    width: var(--sizeBubble);
    aspect-ratio: 1/1;
    border-radius: 50%;
    background: var(--escuro-cinza-color);
    /* background: linear-gradient(180deg, #ffffff  0%, #cacaca  8%, #9f9d9e63 42%, var(--escuro-cinza-color) 88%); */
    background: #858585a1;
    top: var(--topBubble);
    left: var(--leftBubble);
    bottom: var(--bottomBubble);
    right: var(--rightBubble);
    z-index: 10;
    opacity: 63%;
}






/* RODAPE */

.containerBoasVindas .rodape .socials{
    font-size: 0.9em;
    margin-right: 5vw;
    
}







/* CELULAR */

@media(max-width: 767px){

    .containerBoasVindas .subtitle1,
    .containerBoasVindas .subtitleApp2{
        font-size: 1.6em;
    }


    .containerBoasVindas .title .logobabita {
        min-width: 50vw;
        max-width: 50vw;
    }

    .containerBoasVindas .btnComunidade{
        justify-content: space-around;
        width: 85%;
        padding: 5px 10px;
        font-size: 1em;
    }

    .containerBoasVindas .dataVideos{
        width: 53vw;
        font-size: 1em;
    }

    
    /* RELACIONAMENTO */

    .containerBoasVindas .relacionamento{
        text-align: center;
        font-size: 0.9em;
        flex-direction: column;
        width: 90vw;
        padding: 30px 7.5vw;
    }

    .containerBoasVindas .relacionamento > div{
        margin: 8px;
        justify-content: flex-start;
    }
    
    .containerBoasVindas .relacionamento  .icon{
        width: 35px;
    }

    .containerBoasVindas .relacionamento .intro{
        flex-direction: column;
        width: 88vw;
        font-size: 1.3em;
    }

    .containerBoasVindas .relacionamento .textEmailsInfo{
        text-align: left;
    }

    .containerBoasVindas .relacionamento .intro {
        align-items: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/boasVindas.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB;yBACqB;IACrB,oCAAoC;IACpC,2DAA2D;AAC/D;;;AAGA;;IAEI,kBAAkB;IAClB,WAAW;IACX,kCAAkC;IAClC,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,yDAAgD;IAChD,wBAAwB;IACxB,4BAA4B;IAC5B,WAAW;IACX,gBAAgB;IAChB,4FAA4F;AAChG;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,oCAAoC;IACpC,kCAAkC;IAClC,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,yDAAiD;IACjD,wBAAwB;IACxB,4BAA4B;AAChC;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,WAAW;IACX,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,kCAAkC;IAClC,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;;;;;;AAOA,cAAc;;;;AAId;IACI,6BAA6B;AACjC;;;;AAIA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,cAAc;AAClB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;;;AAIA,mBAAmB;;AAEnB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,2BAA2B;IAC3B,wCAAwC;IACxC,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;;AAGA;IACI,uBAAuB;AAC3B;;AAEA;CACC,4EAA0E;AAC3E;;;AAGA;CACC,4EAA0E;AAC3E;;GAEG;IACC,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,iBAAiB;IACjB,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;CACC,4EAAoE;CACpE,eAAe;AAChB;;;;;;;AAOA,WAAW;;AAEX;IACI,eAAe;IACf,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,qCAAqC;IACrC,iHAAiH;IACjH,qBAAqB;IACrB,qBAAqB;IACrB,uBAAuB;IACvB,2BAA2B;IAC3B,yBAAyB;IACzB,WAAW;IACX,YAAY;AAChB;;;;;;;AAOA,WAAW;;AAEX;IACI,gBAAgB;IAChB,iBAAiB;;AAErB;;;;;;;;AAQA,YAAY;;AAEZ;;IAEI;;QAEI,gBAAgB;IACpB;;;IAGA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,6BAA6B;QAC7B,UAAU;QACV,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,cAAc;IAClB;;;IAGA,mBAAmB;;IAEnB;QACI,kBAAkB;QAClB,gBAAgB;QAChB,sBAAsB;QACtB,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,2BAA2B;IAC/B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":[".containerBoasVindas{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    /* width    : 100vw; */\r\n    max-width: 100vw;\r\n    min-height: 100vh;\r\n    min-height: 100svh;\r\n    /* max-height: 100vh;\r\n    max-height: 100svh; */\r\n    background-color: var(--black-color);\r\n    background: linear-gradient(0deg, #3a3a3a 0%, #121212 100%);\r\n}\r\n\r\n\r\n.containerBoasVindas .subtitle1,\r\n.containerBoasVindas .subtitleApp2{\r\n    position: relative;\r\n    z-index: 20;\r\n    font-family: \"Poppins\", sans-serif;\r\n    font-weight: 700;\r\n    color: var(--white-color);\r\n    font-size: 2em;\r\n    margin-top: 30px;\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n\r\n.containerBoasVindas .logobabita{\r\n    position: relative;\r\n    z-index: 20;\r\n    min-width: 10vw;\r\n    max-width: 10vw;\r\n    margin-top: 5px;\r\n    margin-bottom: 20px;\r\n    align-self: center;\r\n    aspect-ratio: 350/111;\r\n    background-image: url('../imgs/logoBabitaW.png');\r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n    z-index: 18;\r\n    margin-top: 20px;\r\n    /* filter: drop-shadow(0px 0px 2px var(--white-color)) drop-shadow(0px 0px 2px #0000004a); */\r\n}\r\n\r\n.containerBoasVindas .player{\r\n    position: relative;\r\n    z-index: 20;\r\n}\r\n\r\n\r\n.containerBoasVindas .btnComunidade{\r\n    position: relative;\r\n    z-index: 20;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 5px 20px;\r\n    background-color: var(--white-color);\r\n    font-family: \"Poppins\", sans-serif;\r\n    font-weight: 700;\r\n    margin-top: 40px;\r\n    font-size: 1.2em;\r\n    cursor: pointer;\r\n    border-radius: 15px;\r\n}\r\n\r\n.containerBoasVindas .btnComunidade .imgWp{\r\n    position: relative;\r\n    z-index: 20;\r\n    min-width: 50px;\r\n    max-width: 50px;\r\n    margin-left: 10px;\r\n    align-self: center;\r\n    aspect-ratio: 1/1;\r\n    background-image: url('../imgs/iconWhatsApp.png');\r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n}\r\n\r\n\r\n.containerBoasVindas .divisor{\r\n    position: relative;\r\n    z-index: 20;\r\n    width: 80vw;\r\n    height: 2px;\r\n    margin: 30px 0 20px 0;\r\n    background-color: var(--white-color);\r\n}\r\n\r\n.containerBoasVindas .subtitleApp{\r\n    position: relative;\r\n    z-index: 20;\r\n    font-family: \"Poppins\", sans-serif;\r\n    font-weight: 700;\r\n    margin-bottom: 40px;\r\n    font-size: 1.9em;\r\n    color: var(--white-color);\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* APP LINKS */\r\n\r\n\r\n\r\n.containerBoasVindas .subtitleApp1{\r\n    background-color: transparent;\r\n}\r\n\r\n\r\n\r\n.containerBoasVindas .dataVideos{\r\n    font-family: \"Poppins\", sans-serif;\r\n    font-weight: 600;\r\n    color: #FFFFFF;\r\n    font-size: 1.5em;\r\n    text-align: center;\r\n    width: 50vw;\r\n    margin: 0 auto;\r\n}\r\n\r\n\r\n.containerBoasVindas .playerPrimeiro{\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.containerBoasVindas .dataPrimeiroVideo{\r\n    margin-bottom: 40px;\r\n}\r\n\r\n.containerBoasVindas .playerSegundo{\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.containerBoasVindas .dataSegundoVideo{\r\n    margin-bottom: 40px;\r\n}\r\n\r\n\r\n\r\n/* RELACIONAMENTO */\r\n\r\n.containerBoasVindas .relacionamento{\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    position: relative;\r\n    z-index: 20;\r\n    width: 80vw;\r\n    padding: 30px 10vw;\r\n    font-family: \"Poppins\", sans-serif;\r\n    font-weight: 700;\r\n    font-size: 1em;\r\n    color: var(--white-color);\r\n    margin-bottom: 60px;\r\n    background-color: #3a3a3ab4;\r\n    border-top: 1px solid var(--white-color);\r\n    border-bottom: 1px solid var(--white-color);\r\n}\r\n\r\n.containerBoasVindas .relacionamento > div{\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.containerBoasVindas .relacionamento .intro{\r\n    flex-direction: column;\r\n    width: 18vw;\r\n}\r\n\r\n.containerBoasVindas .relacionamento span{\r\n    font-weight: 500;\r\n}\r\n\r\n.containerBoasVindas .relacionamento  .icon{\r\n    width: 50px;\r\n    aspect-ratio: 1/1;\r\n    margin-right: 20px;\r\n}\r\n\r\n\r\n.containerBoasVindas .relacionamento .intro {\r\n    align-items: flex-start;\r\n}\r\n\r\n.containerBoasVindas .relacionamento .textInfoTel .icon{\r\n background: url('../imgs/bemVindo/phoneIcon.png') no-repeat center/contain;\r\n}\r\n\r\n\r\n.containerBoasVindas .relacionamento .textInfoEmail .icon{\r\n background: url('../imgs/bemVindo/emailIcon.png') no-repeat center/contain;\r\n}\r\n\r\n   .containerBoasVindas .relacionamento .textInfoWp{\r\n    display: flex;\r\n    align-items: center;\r\n    background-color: var(--white-color);\r\n    padding: 8px 20px;\r\n    font-family: \"Poppins\", sans-serif;\r\n    font-weight: 700;\r\n    cursor: pointer;\r\n    border-radius: 10px;\r\n    max-height: 70px;\r\n    color: var(--black-color);\r\n}\r\n\r\n.containerBoasVindas .relacionamento .textInfoWp .icon{\r\n    width: 50px;\r\n    aspect-ratio: 1/1;\r\n    margin-right: 10px;\r\n}\r\n\r\n.containerBoasVindas .relacionamento .textInfoWp .icon{\r\n background: url('../imgs/iconWhatsApp.png') no-repeat center/contain;\r\n cursor: pointer;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* BOLHAS */\r\n\r\n.containerBoasVindas .bubble{\r\n    position: fixed;\r\n    width: var(--sizeBubble);\r\n    aspect-ratio: 1/1;\r\n    border-radius: 50%;\r\n    background: var(--escuro-cinza-color);\r\n    /* background: linear-gradient(180deg, #ffffff  0%, #cacaca  8%, #9f9d9e63 42%, var(--escuro-cinza-color) 88%); */\r\n    background: #858585a1;\r\n    top: var(--topBubble);\r\n    left: var(--leftBubble);\r\n    bottom: var(--bottomBubble);\r\n    right: var(--rightBubble);\r\n    z-index: 10;\r\n    opacity: 63%;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* RODAPE */\r\n\r\n.containerBoasVindas .rodape .socials{\r\n    font-size: 0.9em;\r\n    margin-right: 5vw;\r\n    \r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* CELULAR */\r\n\r\n@media(max-width: 767px){\r\n\r\n    .containerBoasVindas .subtitle1,\r\n    .containerBoasVindas .subtitleApp2{\r\n        font-size: 1.6em;\r\n    }\r\n\r\n\r\n    .containerBoasVindas .title .logobabita {\r\n        min-width: 50vw;\r\n        max-width: 50vw;\r\n    }\r\n\r\n    .containerBoasVindas .btnComunidade{\r\n        justify-content: space-around;\r\n        width: 85%;\r\n        padding: 5px 10px;\r\n        font-size: 1em;\r\n    }\r\n\r\n    .containerBoasVindas .dataVideos{\r\n        width: 53vw;\r\n        font-size: 1em;\r\n    }\r\n\r\n    \r\n    /* RELACIONAMENTO */\r\n\r\n    .containerBoasVindas .relacionamento{\r\n        text-align: center;\r\n        font-size: 0.9em;\r\n        flex-direction: column;\r\n        width: 90vw;\r\n        padding: 30px 7.5vw;\r\n    }\r\n\r\n    .containerBoasVindas .relacionamento > div{\r\n        margin: 8px;\r\n        justify-content: flex-start;\r\n    }\r\n    \r\n    .containerBoasVindas .relacionamento  .icon{\r\n        width: 35px;\r\n    }\r\n\r\n    .containerBoasVindas .relacionamento .intro{\r\n        flex-direction: column;\r\n        width: 88vw;\r\n        font-size: 1.3em;\r\n    }\r\n\r\n    .containerBoasVindas .relacionamento .textEmailsInfo{\r\n        text-align: left;\r\n    }\r\n\r\n    .containerBoasVindas .relacionamento .intro {\r\n        align-items: center;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
